import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import type { Theme } from '@mui/material/styles';

export default function Select(_theme: Theme) {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: ExpandMoreRoundedIcon
      },

      styleOverrides: {
        root: {}
      }
    }
  };
}
